import { EditOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client/react';
import { App, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import type React from 'react';
import { useEffect } from 'react';
import type { InsuranceInput } from '../../../graphql/generated/graphql.ts';
import type { Insurance } from '../Insurances.tsx';
import { InsuranceForm } from './InsuranceForm';
import { UPDATE_INSURANCE_MUTATION } from './UpdateInsuranceModal.gql';

export const UpdateInsuranceModal: React.FC<{
  onClose: () => void;
  allInsurances: Insurance[];
  insurance: Insurance | null;
}> = ({ onClose, allInsurances, insurance }) => {
  const [updateInsuranceMutation, { loading }] = useMutation(UPDATE_INSURANCE_MUTATION);
  const [form] = useForm<InsuranceInput>();
  const { message } = App.useApp();

  const update = async (values: InsuranceInput) => {
    try {
      await updateInsuranceMutation({
        variables: {
          id: insurance?.id ?? '',
          input: values,
        },
      });

      message.success('Krankenkasse wurde aktualisiert');
      closeAndReset();
    } catch (e) {
      message.error(`Krankenkasse konnte nicht aktualisiert werden: ${e}`);
    }
  };

  const closeAndReset = () => {
    form.resetFields();
    onClose();
  };

  useEffect(() => {
    form.setFieldsValue({
      name: insurance?.name ?? '',
      shortName: insurance?.shortName ?? '',
      code: insurance?.code ?? '',
      mappings: insurance?.mappings ?? [],
    });
  }, [form, insurance]);

  return (
    <Modal
      width={768}
      title="Krankenkasse bearbeiten"
      okText="Speichern"
      okButtonProps={{ icon: <EditOutlined /> }}
      open={!!insurance}
      onCancel={closeAndReset}
      onOk={form.submit}
      confirmLoading={loading}
      destroyOnHidden
      forceRender
    >
      <InsuranceForm
        form={form}
        onFinish={update}
        codeValidator={code => !allInsurances.filter(i => i.id !== insurance?.id).some(i => i.code === code)}
      />
    </Modal>
  );
};
